import { render } from "./warehouse-attachment.vue?vue&type=template&id=3f0d5c3a"
import script from "./warehouse-attachment.vue?vue&type=script&lang=js"
export * from "./warehouse-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__